import { Button } from '@mui/material';
import { MatchResultEnum } from 'domain/event/match/MatchResult.enum';
import { ITeamRepository } from 'domain/team/Team.repository';
import { KeyValue } from 'primary/Components/KeyValue/KeyValue';
import {
  getNavigationLinkFromRessourceKey,
  parseRessourceFromNotificaton,
} from 'primary/MessageList/NotificationListItem';
import React from 'react';
import { useNavigate } from 'react-router-dom';

import { NotificationResourceTypeEnum } from '../../../domain/notification/NotificationResourceTypeEnum';
import { UnpyNotification } from '../../../domain/notification/UnpyNotification';
import {
  TranslationOption,
  TranslationType,
} from '../../../domain/translation/Translation.repository';
import { useContextDependency } from '../../hooks/useContextDependency';
import { useTranslate } from '../../hooks/useTranslate';

interface NotificationInvitationTeamEventContentProps {
  notification: UnpyNotification;
  reFetchNotification: () => void;
  closePreview?: () => void;
}

export const getOnClickResponseInvitationTeamEventParticipation = (
  teamRepository: ITeamRepository,
  t: (key: TranslationType, option?: TranslationOption) => string,
  response: boolean,
  reFetchNotification: () => void,
  teamId: number,
  eventId: number,
  setLoading: (loading: boolean) => void,
  accept: boolean,
) => {
  return () => {
    setLoading(true);
    if (accept) {
      teamRepository.acceptTeamInvitationEvent(response, teamId, eventId).then(() => {
        reFetchNotification();
        setLoading(false);
      });
    } else {
      teamRepository.declineTeamInvitationEvent(eventId, teamId).then(() => {
        reFetchNotification();
        setLoading(false);
      });
    }
  };
};

export const NotificationScoreUpdatedContent = ({
  notification,
  reFetchNotification,
  closePreview,
}: NotificationInvitationTeamEventContentProps) => {
  const t = useTranslate();
  const { eventParticipantRepository, teamRepository, eventRepository, authRepository } =
    useContextDependency();
  const ressourcesParsed = parseRessourceFromNotificaton(notification);
  const navigate = useNavigate();

  return (
    <div>
      <div className={'-keyValueContainerNotification'}>
        <div className={'-scoreUpdated'}>
          <KeyValue
            accent
            keyValue={t(
              `notificationList.item.ressourceLabelByKey.${NotificationResourceTypeEnum.EVENT_NAME}`,
            )}
            value={notification.resources[NotificationResourceTypeEnum.EVENT_NAME]}
          />
          <div className={'-scores'}>
            <KeyValue
              accent
              keyValue={t(
                `notificationList.item.ressourceLabelByKey.${NotificationResourceTypeEnum.NAME_TEAM_1}`,
              )}
              value={notification.resources[NotificationResourceTypeEnum.NAME_TEAM_1]}
            />
            <KeyValue
              accent
              keyValue={t(
                `notificationList.item.ressourceLabelByKey.${NotificationResourceTypeEnum.SCORE_TEAM_1}`,
              )}
              value={t(
                `enum.matchResult.${
                  notification.resources[
                    NotificationResourceTypeEnum.SCORE_TEAM_1
                  ] as MatchResultEnum
                }`,
              )}
            />
          </div>
          <div className={'-scores'}>
            <KeyValue
              accent
              keyValue={t(
                `notificationList.item.ressourceLabelByKey.${NotificationResourceTypeEnum.NAME_TEAM_2}`,
              )}
              value={notification.resources[NotificationResourceTypeEnum.NAME_TEAM_2]}
            />
            <KeyValue
              accent
              keyValue={t(
                `notificationList.item.ressourceLabelByKey.${NotificationResourceTypeEnum.SCORE_TEAM_2}`,
              )}
              value={t(
                `enum.matchResult.${
                  notification.resources[
                    NotificationResourceTypeEnum.SCORE_TEAM_2
                  ] as MatchResultEnum
                }`,
              )}
            />
          </div>
        </div>
      </div>
      <div className={'-linkContainerNotification'}>
        {ressourcesParsed
          .filter((r) => r.isLink)
          .map((res) => (
            <Button
              key={res.keyValue}
              variant={'outlined'}
              className={'-linkNotification'}
              onClick={() => {
                const link = getNavigationLinkFromRessourceKey(
                  res.keyValue as NotificationResourceTypeEnum,
                  res.value,
                  notification.resources,
                  notification.type,
                );
                navigate(link);
                closePreview?.();
              }}
            >
              {t(
                `notificationList.item.ressourceLabelByKey.${
                  res.keyValue as NotificationResourceTypeEnum
                }`,
              )}
            </Button>
          ))}
      </div>
    </div>
  );
};
